// add your site specific javascript here
$(document).ready(() => {
  'use strict'

  $.ajaxSetup({
    cache: true
  })

  // For crawler
  if (!window.JS_ENABLED) {
    $.ajax({
      url: window.makeUrl({ module: 'eshop', action: 'setJavascriptEnabled' }),
      type: 'post',
      dataType: 'json'
    })
  }

  // Return to top
  $(window).scroll(function () {
    if ($(this).scrollTop() > 200) { // If the page is scrolled more than 200px
      $('#return-to-top').fadeIn(200)
    } else {
      $('#return-to-top').fadeOut(200)
    }
  })
  $('#return-to-top').click(() => {
    $('body,html').animate({
      scrollTop: 0
    }, 500)
  })

  //Search
  $('[data-zg-role="btn-search"]').on('click',function() {
    const $searchContainer = $(this).next('#searchContainer')
    $searchContainer.toggleClass('d-none')
    $(this).toggleClass('d-none')
  })

//Close search
  $('[data-zg-role="close-search"]').on('click',function() {
    const $searchContainer = $(this).closest('#searchContainer')
    $searchContainer.prev('[data-zg-role="btn-search"]').toggleClass('d-none')
    $searchContainer.toggleClass('d-none');
  })

  // Increasing-decreasing qty input
  $('[data-zg-role="change-qty"]').click(function () {
    event.preventDefault()
    const type = $(this).data('type')
    const $inputQtySibling = $(this).parent().siblings('[data-zg-role="quantity"]')
    const maxQty = $inputQtySibling.data('max')
    const floatQty = $inputQtySibling.data('floatQty')
    let qty = $inputQtySibling.val()
    let step

    step = floatQty ? 0.01 : 1

    qty = Number(qty)

    $('[data-zg-role="change-qty"]').attr('disabled', false)
    if (type == 'minus') {
      // If qty is 0, we will disable the current minus icon.
      // The next time this function will be run, all the change qty icons will be enabled again.
      if (qty == 0) {
        $(this).attr('disabled', true)
      } else {
        qty -= step
      }
    } else {
      // If qty is equal to maxQty, we will disable the current plus icon.
      // The next time this function will be run, all the change qty icons will be enabled again.
      if (qty == maxQty) {
        $(this).attr('disabled', true)
      } else {
        qty += step
      }
    }

    $(this).parent().siblings('[data-zg-role="quantity"]').val(qty)
  })

  /* Added to calculate the height to center the arrows regard to the image height */
  function heightArrowsSlider(slider) {
    const topHeight = ($('.' + slider).find('img').height() / 100 * 60)
    $('.slick-arrow').css('top', topHeight + 'px')
  }

  $('.slider-related-post').on('init', slick => {
    heightArrowsSlider('slider-related-post')
  })

  $(window).on('resize', _.debounce(() => {
    heightArrowsSlider('slider-related-post')
  }, 200))

  if($('[data-zg-role="slider"]') && typeof $.fn.slick == 'function') {
    $('[data-zg-role="slider"]').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      centerPadding: '0px',
      draggable: true,
      speed: 200,
      prevArrow: '<div class="slick-prev"><i class="bi bi-chevron-left"></i><span class="visually-hidden visually-hidden-focusable"><</span></div>',
      nextArrow: '<div class="slick-next"><i class="bi bi-chevron-right"></i><span class="visually-hidden visually-hidden-focusable">></span></div>',
      responsive: [

        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    })
  }

})

if (typeof parseDataToForm !== 'function') {
  function parseDataToForm(object) {
    const formData = new FormData()
    for (const key of Object.keys(object)) {
      if (typeof object[key] !== 'object') {
        formData.append(key, object[key])
      } else {
        formData.append(key, JSON.stringify(object[key]))
      }
    }

    return formData
  }
}

/*Open and close menu mobile nested dropdowns on click */

document
    .querySelectorAll('.dropdown-menu .dropdown-toggle[href="#"]')
    .forEach(function (element) {
      element.addEventListener("click", function (event) {
        event.stopPropagation();
      });
    });

if(IS_FIRST_LOGIN){
  var registrationModal = new bootstrap.Modal(document.getElementById('registrationModalThanks'));
  registrationModal.show();
}
